export default __webpack_public_path__ + "static/media/wm_back.8802c887.png";